const groupMarketSegmentFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const segmentGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`segment-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `segment-${index}-title`)) {
      break;
    }

    segmentGroups.push({ index, fields: groupFields });
  }

  return { introFields, segmentGroups };
};

export default groupMarketSegmentFields;
